module.exports = __webpack_public_path__ + "img/sankaku_76_red.798b9716.png";